import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import logoImage from '../ux/catlogo4.png';

const NotFound = ({ onGoHome }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#FAFAFA',
        textAlign: 'center',
        px: 3,
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src={logoImage}
        alt="dobrynajemca.pl"
        sx={{ height: 60, mb: 4, opacity: 0.9 }}
      />

      {/* Duże 404 */}
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: '6rem', sm: '9rem' },
          fontWeight: 800,
          color: '#D2691E',
          lineHeight: 1,
          mb: 1,
          letterSpacing: '-4px',
        }}
      >
        404
      </Typography>

      <Typography
        variant="h5"
        sx={{ fontWeight: 600, color: '#333', mb: 1 }}
      >
        Strona nie istnieje
      </Typography>

      <Typography
        variant="body1"
        sx={{ color: '#888', mb: 4, maxWidth: 380 }}
      >
        Strona, której szukasz, mogła zostać usunięta lub adres jest nieprawidłowy.
      </Typography>

      <Button
        variant="contained"
        startIcon={<HomeIcon />}
        onClick={onGoHome}
        sx={{
          backgroundColor: '#D2691E',
          '&:hover': { backgroundColor: '#B85C00' },
          textTransform: 'none',
          borderRadius: 2,
          px: 4,
          py: 1.5,
          fontSize: '1rem',
          fontWeight: 600,
        }}
      >
        Wróć na stronę główną
      </Button>

      <Typography
        variant="caption"
        sx={{ color: '#bbb', mt: 6 }}
      >
        © {new Date().getFullYear()} dobrynajemca.pl
      </Typography>
    </Box>
  );
};

export default NotFound;
